import { useSnackbar } from 'notistack'

export const createMessages = (name?: string) => {
  const { enqueueSnackbar } = useSnackbar()
  return {
    updateSuccess: (n?:string) =>
      enqueueSnackbar(`${name || n}の編集が完了しました。`, {
        variant: 'success',
      }),
    createSuccess: (n?: string) =>
      enqueueSnackbar(`${name || n}の作成が完了しました。`, {
        variant: 'success',
      }),
    deleteSuccess: (n?: string) =>
      enqueueSnackbar(`${name || n}の削除が完了しました。`, {
        variant: 'success',
      }),
    deleteError: (n?: string) =>
      enqueueSnackbar(`${name || n}の削除に失敗しました。`, {
        variant: 'error',
        persist: true,
      }),
    success: (message: string) =>
      enqueueSnackbar(message, {
        variant: 'success',
      }),
    error: (error: string) =>
      enqueueSnackbar(`${JSON.stringify(error)}`, {
        variant: 'error',
        persist: true,
      }),
  };
};

export default createMessages
